import { setReference } from 'actions/timeline'
import { MEDIA_TYPE } from 'enums'
import { isEmpty, isNil, maxBy } from 'lodash'
import { isStretched, isVideo } from 'Util/assets'
import { getOutputFormat } from 'Util/project'
import * as Selectors from '~/selectors'
import { DEFAULT_FPS, DEFAULT_VIDEO_HEIGHT, DEFAULT_VIDEO_WIDTH } from '~/Util'

export const adjustProjectReference = project => async (dispatch, getState) => {
  const state = getState()
  const allAssets = Selectors.getAssets(state)
  const reference = Selectors.getReferenceVideoAsset(state)
  const videoAssets = allAssets.filter(a => isVideo(a))
  const longestVideoAsset = maxBy(videoAssets, 'duration')
  const isVideoAssetsOnly = !isEmpty(allAssets) && allAssets.every(a => isVideo(a))
  const allVideoAssetsStretched = !isEmpty(allAssets) && allAssets.every(
    a => isVideo(a) && isStretched(a)
  )
  const noVideoAssets = isEmpty(videoAssets)
  const { width, height, fpsNum, fpsDenum, fileId, filetype: fileType } = longestVideoAsset ?? {}

  let nextReference = {}

  if (project) {
    nextReference = { ...project.reference }
  } else {
    nextReference = { ...reference }
  }

  const missingRef = !allAssets.find(a => reference.id && (a.fileId === reference.id))

  if (missingRef) {
    nextReference.id = null
  }

  const noRefParams = isNil(nextReference.width) && isNil(nextReference.height)

  if ((project && isEmpty(project.reference)) || noRefParams) {
    nextReference = {
      width: noVideoAssets ? DEFAULT_VIDEO_WIDTH : width,
      height: noVideoAssets ? DEFAULT_VIDEO_HEIGHT : height,
      fpsNum: noVideoAssets ? DEFAULT_FPS : fpsNum,
      fpsDenum: noVideoAssets ? 1 : fpsDenum,
      id: noVideoAssets ? null : fileId,
      fileType: noVideoAssets ? MEDIA_TYPE.MP4 : getOutputFormat({ fileType }),
    }
    // need set id, width, height, fpsNum, fpsDenum, fileType from longed video asset
  } else if (!nextReference.id && isVideoAssetsOnly && allVideoAssetsStretched) {
    nextReference = {
      id: fileId,
      width,
      height,
      fpsNum,
      fpsDenum,
      fileType: getOutputFormat({ fileType }),
    }
  }
  // always check change/set refrence.id  from video that matches reference (width,height, fpsNum, fpsDenum)  with max duration
  if (nextReference.width && nextReference.height
    && nextReference.fpsNum && nextReference.fpsDenum) {
    const { width, height, fpsNum, fpsDenum } = nextReference
    // we are looking for the longest one with the same parameters
    const longestSameParamsAsset = maxBy(videoAssets.filter(a => a.width === width
      && a.height === height
      && a.fpsNum === fpsNum
      && a.fpsDenum === fpsDenum), 'duration')
    if (longestSameParamsAsset) {
      nextReference = {
        ...nextReference,
        id: longestSameParamsAsset.fileId,
      }
    }
  }

  if (!nextReference.fileType) {
    nextReference = {
      ...nextReference,
      fileType: noVideoAssets
        ? MEDIA_TYPE.MP4
        : getOutputFormat({ fileType }),
    }
  }

  dispatch(setReference(nextReference))
}
